module.exports = "/_next/static/images/40cd01db4c3a4d6c4529d99145ba9392-cuenta-ric.svg";